import React from 'react';
import { KPIS } from '../../data/insights';
import { CountUp } from './CountUp';
export function KpiStrip() {
  return <section aria-labelledby="kpi-title" className="mt-7 rounded-2xl bg-white" data-id="element-95" data-mp="33cxr5pbd3u6c">
      <h3 id="kpi-title" className="px-5 pt-4 text-[13px] font-semibold text-ink" data-id="element-96" data-mp="3hbno94y6ltup">
        Campaign performance
      </h3>
      <dl className="grid grid-cols-2 md:grid-cols-4" data-id="element-97" data-mp="3cbj3h2q8qcyo">
        {KPIS.map((k, i) => <div key={k.label} className={`flex flex-col px-5 pb-5 pt-3 ${i > 0 ? 'md:border-l md:border-hair' : ''}`} data-id="element-98" data-mp="3r8jrav5b9nrv" data-mpi={i}>
            <dt className="text-[12.5px] text-graphite" data-id="element-99" data-mp="3m9yw5a4x1uaa">{k.label}</dt>
            <dd className="mt-1 flex items-baseline gap-0.5" data-id="element-100" data-mp="3wr5fdf98q9d">
              <CountUp value={k.value} format={k.format} className={`font-serif leading-none tracking-[-0.02em] ${i === 0 ? 'text-[44px] text-navy' : 'text-[38px] text-ink'}`} data-id="element-101" data-mp="3w0a2t4fzihkv" />
              {k.format === 'pct' && <span className="font-serif text-[20px] text-graphite" data-id="element-102" data-mp="8x5d2ucy1y6v">%</span>}
              {k.format === 'time' && <span className="ml-1 text-[12px] text-graphite" data-id="element-103" data-mp="1n40e8cbdc0wv">min</span>}
            </dd>
            <dd className="mt-2 text-[11.5px] leading-snug text-graphite/90" data-id="element-104" data-mp="1s1sh21djx7fu">{k.note}</dd>
          </div>)}
      </dl>
    </section>;
}